/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationSalesDelete
 */
export interface OrganizationSalesDelete {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesDelete
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesDelete
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationSalesDelete interface.
 */
export function instanceOfOrganizationSalesDelete(value: object): value is OrganizationSalesDelete {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationSalesDeleteFromJSON(json: any): OrganizationSalesDelete {
    return OrganizationSalesDeleteFromJSONTyped(json, false);
}

export function OrganizationSalesDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSalesDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationSalesDeleteToJSON(json: any): OrganizationSalesDelete {
    return OrganizationSalesDeleteToJSONTyped(json, false);
}

export function OrganizationSalesDeleteToJSONTyped(value?: OrganizationSalesDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

